<template>
    <div ref="playerWrapper"
         class="pip-player-control-wrapper">
        <PlayerControls />
        <div v-if="feedback.show" :class="['seek-feedback', feedback.direction]">
            {{ feedback.text }}
        </div>
    </div>
</template>

<script setup>
    import { inject, ref, onMounted } from "vue";

    import PlayerControls from "@/components/Streaming/PlayerControls.vue";

    const videoPlayer = inject("pipVideoPlayer");
    const pipWindow = inject("pipWindow");
    const playerWrapper = ref(null);
    const previewCanvas = ref(null);
    const feedback = inject("pipFeedback");

</script>

<style scoped>
      .pip-player-control-wrapper {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        z-index: 10000;
        /*
     * 전체 wrapper가 이벤트를 먹지 않도록
     */
        pointer-events: none;
        user-select: none;
        -webkit-user-select: none;
    }

    .seek-feedback {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 10001;
        padding: 8px 14px;
        font-size: 20px;
        font-weight: bold;
        background: rgba(0, 0, 0, 0.7);
        color: white;
        border-radius: 6px;
        pointer-events: none;
    }
</style>